import { z } from 'zod';
import { GeoCountries, GeoSubdivisions, HobbiesFeatures, HobbyCatalogItem, HobbyMeetup, } from '../../hobbies.js';
import { AddHobbyInput, HobbiesProfile, HobbiesQuery, TrackedHobby, HobbyGoal, HobbyLogInput, HobbyLog, HobbyProgress, HobbyProgressQuery, HobbyDeleted, SortHobbyInput, } from '../../hobbies.js';
export const hobbiesRoutes = {
    meetups: {
        method: 'GET',
        path: '/hobbies/meetups',
        response: z.object({ items: z.array(HobbyMeetup).max(3) }),
    },
    profile: {
        method: 'GET',
        path: '/users/:userId/profile/hobbies',
        query: HobbiesQuery,
        response: HobbiesProfile,
    },
    add: { method: 'POST', path: '/me/hobbies', body: AddHobbyInput, response: TrackedHobby },
    sort: { method: 'PATCH', path: '/me/hobbies/:id', body: SortHobbyInput, response: TrackedHobby },
    remove: { method: 'DELETE', path: '/me/hobbies/:id', response: HobbyDeleted },
    goal: { method: 'PUT', path: '/me/hobbies/:id/goal', body: HobbyGoal, response: TrackedHobby },
    removeGoal: { method: 'DELETE', path: '/me/hobbies/:id/goal', response: TrackedHobby },
    log: { method: 'POST', path: '/me/hobbies/:id/logs', body: HobbyLogInput, response: HobbyLog },
    removeLog: { method: 'DELETE', path: '/me/hobbies/logs/:logId', response: HobbyDeleted },
    progress: {
        method: 'GET',
        path: '/me/hobbies/:id/progress',
        query: HobbyProgressQuery,
        response: HobbyProgress,
    },
    features: {
        method: 'GET',
        path: '/hobbies/features',
        response: HobbiesFeatures,
    },
    catalog: {
        method: 'GET',
        path: '/hobbies/catalog',
        response: z.array(HobbyCatalogItem),
    },
    countries: {
        method: 'GET',
        path: '/geo/countries',
        response: GeoCountries,
    },
    subdivisions: {
        method: 'GET',
        path: '/geo/countries/:code/subdivisions',
        response: GeoSubdivisions,
    },
};
//# sourceMappingURL=routes.js.map